export const mediaUrl = (path) => {
  if (!path) return "";
  const mediaUrl = import.meta.env.VITE_MEDIA_URL;

  if (path.startsWith("http")) {
    return path; // already a full URL
  }

  // google drive url
  if (path.startsWith("https://drive.google.com/file/d/")) {
    const fileId = path.split("/").pop();
    return `https://drive.google.com/uc?export=download&id=${fileId}`;
  }
  return `${mediaUrl}/${path}`; // already a relative path
};
